// extracted by mini-css-extract-plugin
module.exports = {"SaveToListWrapper":"SaveToList_SaveToListWrapper__cKoDD"};